/**
 * @generated SignedSource<<0019048b42898dc5412087206f0304aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PerspectivesImportInputObject = {
  json: string;
};
export type categorizePage_PerspectivesImportMutation$variables = {
  input: PerspectivesImportInputObject;
};
export type categorizePage_PerspectivesImportMutation$data = {
  readonly perspectivesImport: {
    readonly categoriesImported: number | null | undefined;
    readonly categorizationsImported: number | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly perspectivesImported: number | null | undefined;
  } | null | undefined;
};
export type categorizePage_PerspectivesImportMutation = {
  response: categorizePage_PerspectivesImportMutation$data;
  variables: categorizePage_PerspectivesImportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "perspectivesImported",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoriesImported",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categorizationsImported",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "categorizePage_PerspectivesImportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PerspectivesImportMutationPayload",
        "kind": "LinkedField",
        "name": "perspectivesImport",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "categorizePage_PerspectivesImportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PerspectivesImportMutationPayload",
        "kind": "LinkedField",
        "name": "perspectivesImport",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b6a3ce4f49a62cec891048c18dd68806",
    "id": null,
    "metadata": {},
    "name": "categorizePage_PerspectivesImportMutation",
    "operationKind": "mutation",
    "text": "mutation categorizePage_PerspectivesImportMutation(\n  $input: PerspectivesImportInputObject!\n) {\n  perspectivesImport(input: $input) {\n    perspectivesImported\n    categoriesImported\n    categorizationsImported\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4cf544d24687a9dd17d39fbf06c749b6";

export default node;
